import {
    ADD_SMART_FILTER_CONDITION,
    AddSmartFilterConditionAction,
    CHANGE_SMART_FILTER_CONDITION_FIELD,
    CHANGE_SMART_FILTER_CONDITION_OPERATOR,
    CHANGE_SMART_FILTER_CONDITION_VALUES,
    ChangeSmartFilterConditionFieldAction,
    ChangeSmartFilterConditionOperatorAction,
    ChangeSmartFilterConditionValuesAction,
    REMOVE_SMART_FILTER_CONDITION,
    RemoveSmartFilterConditionAction,
    SmartFilterConditionsAction
} from '../../actions/smartFilterConditions';
import { ListHelpers } from '../../service/ListHelpers/ListHelpers';
import { EditGroupsState, FeedFilterCondition } from '../../typings/groupsEditState';

const addSmartFilterCondition = (state: EditGroupsState, action: AddSmartFilterConditionAction): EditGroupsState => {
    const {
        groupFilterInspector,
        groupFilterInspector: { filter }
    } = state;
    const { condition } = action;

    return {
        ...state,
        groupFilterInspector: {
            ...groupFilterInspector,
            filter: {
                ...filter,
                conditions: [...filter.conditions, condition],
                errors: {
                    ...filter.errors,
                    allConditions: {},
                    filterItself: {}
                }
            }
        }
    };
};

const removeSmartFilterCondition = (
    state: EditGroupsState,
    action: RemoveSmartFilterConditionAction
): EditGroupsState => {
    const {
        groupFilterInspector,
        groupFilterInspector: { filter }
    } = state;
    const { id } = action;

    return {
        ...state,
        groupFilterInspector: {
            ...groupFilterInspector,
            filter: {
                ...filter,
                conditions: filter.conditions.filter(condition => condition.id !== id),
                errors: {
                    ...filter.errors,
                    filterItself: {}
                }
            }
        }
    };
};

const changeSmartFilterConditionField = (
    state: EditGroupsState,
    action: ChangeSmartFilterConditionFieldAction
): EditGroupsState => {
    const {
        groupFilterInspector,
        groupFilterInspector: { filter }
    } = state;
    const { id, field } = action.payload;

    return {
        ...state,
        groupFilterInspector: {
            ...groupFilterInspector,
            filter: {
                ...filter,
                conditions: ListHelpers.updateItem<FeedFilterCondition>(
                    filter.conditions,
                    condition => condition.id === id,
                    { field, arguments: [], errors: [] }
                ),
                errors: {
                    ...filter.errors,
                    filterItself: {}
                }
            }
        }
    };
};

const changeSmartFilterConditionOperator = (
    state: EditGroupsState,
    action: ChangeSmartFilterConditionOperatorAction
): EditGroupsState => {
    const {
        groupFilterInspector,
        groupFilterInspector: { filter }
    } = state;
    const { id, operator, values } = action.payload;

    return {
        ...state,
        groupFilterInspector: {
            ...groupFilterInspector,
            filter: {
                ...filter,
                conditions: ListHelpers.updateItem<FeedFilterCondition>(
                    filter.conditions,
                    condition => condition.id === id,
                    { operator, arguments: values || [], errors: [] }
                ),
                errors: {
                    ...filter.errors,
                    filterItself: {}
                }
            }
        }
    };
};

const changeSmartFilterConditionValues = (
    state: EditGroupsState,
    action: ChangeSmartFilterConditionValuesAction
): EditGroupsState => {
    const {
        groupFilterInspector,
        groupFilterInspector: { filter }
    } = state;
    const { id, values } = action.payload;

    return {
        ...state,
        groupFilterInspector: {
            ...groupFilterInspector,
            filter: {
                ...filter,
                conditions: ListHelpers.updateItem<FeedFilterCondition>(
                    filter.conditions,
                    condition => condition.id === id,
                    { arguments: values, errors: [] }
                ),
                errors: {
                    ...filter.errors,
                    filterItself: {}
                }
            }
        }
    };
};

export const conditionsReducer = (state: EditGroupsState, action: SmartFilterConditionsAction): EditGroupsState => {
    switch (action.type) {
        case ADD_SMART_FILTER_CONDITION:
            return addSmartFilterCondition(state, action);
        case REMOVE_SMART_FILTER_CONDITION:
            return removeSmartFilterCondition(state, action);
        case CHANGE_SMART_FILTER_CONDITION_FIELD:
            return changeSmartFilterConditionField(state, action);
        case CHANGE_SMART_FILTER_CONDITION_OPERATOR:
            return changeSmartFilterConditionOperator(state, action);
        case CHANGE_SMART_FILTER_CONDITION_VALUES:
            return changeSmartFilterConditionValues(state, action);
        default:
            return state;
    }
};
